export const standardFieldOptions = [
  {
    value: "events.event",
    type: "timestamp",
  },
  {
    value: "user_organizations.organization_id",
    type: "number",
  },
  // {
  //   value: "user_organizations.open_to_sharing_within_1m",
  //   type: "number",
  // },
  // {
  //   value: "user_organizations.all_within_1m",
  //   type: "number",
  // },
  {
    value: "organizations.name",
  },
  {
    value: "organizations.logo",
  },
  {
    value: "organizations.school_type",
    type: "choices",
    choices: [
      { name: "COUNCIL", value: "COUNCIL" },
      { name: "INDEPENDENT", value: "INDEPENDENT" },
    ],
  },
  {
    value: "organizations.code",
  },
  {
    value: "organizations.staff_code",
  },
  {
    value: "organizations.launch_code",
  },
  {
    value: "organizations.created_at",
    type: "timestamp",
  },
  {
    value: "users.id",
    type: "number",
  },
  {
    value: "users.email",
    type: "string",
    // type: "email",
  },
  {
    value: "users.first_name",
  },
  {
    value: "users.last_name",
  },
  // {
  //   value: "users.is_staff",
  //   type: "choices",
  //   choices: [
  //     { name: "Yes", value: 1 },
  //     { name: "No", value: 0 },
  //   ],
  // },
  {
    value: "roles.slug",
    type: "choices",
    choices: [
      { name: "PARENT", value: "PARENT" },
      { name: "STAFF", value: "STAFF" },
    ],
  },
  {
    value: "user_role_settings.staff_type",
    type: "choices",
    choices: [
      { name: "Support staff", value: "SUPPORT_STAFF" },
      { name: "Teaching staff", value: "TEACHING_STAFF" },
    ],
  },
  // {
  //   value: "users.not_a_parent",
  //   type: "choices",
  //   choices: [
  //     { name: "Yes", value: 1 },
  //     { name: "No", value: 0 },
  //   ],
  // },
  {
    value: "users.salutation",
    type: "choices",
    choices: [
      { name: "Mr", value: "Mr" },
      { name: "Mrs", value: "Mrs" },
      { name: "Ms", value: "Ms" },
      { name: "Miss", value: "Miss" },
    ],
  },
  {
    value: "users.new_term",
    type: "choices",
    choices: [
      { name: "Yes", value: 1 },
      { name: "No", value: 0 },
    ],
  },
  {
    value: "users.last_viewed",
    type: "unix_timestamp",
  },
  {
    value: "users.verified",
    type: "choices",
    choices: [
      { name: "Yes", value: 1 },
      { name: "No", value: 0 },
    ],
  },
  {
    value: "users.app_login",
    type: "choices",
    choices: [
      { name: "Yes", value: 1 },
      { name: "No", value: 0 },
    ],
  },
  {
    value: "users.created_at",
    type: "timestamp",
  },
  {
    value: "user_role_settings.sharing_journey",
    type: "choices",
    choices: [
      { name: "Yes", value: 1 },
      { name: "No", value: 0 },
    ],
  },
  {
    value: "parents.journey_preference",
    type: "number",
  },
  {
    value: "terms_archive.parent2_user_id",
    type: "number",
  },
  {
    value: "terms_archive.term",
    type: "choices",
    choices: [
      { name: "Current", value: "current" },
      { name: "Autumn", value: "autumn" },
      { name: "Spring", value: "spring" },
    ],
  },
  {
    value: "terms_archive.fuel_type",
    type: "choices",
    choices: [
      { name: "Petrol", value: "PETROL" },
      { name: "Diesel", value: "DIESEL" },
      { name: "Electric", value: "ELECTRIC" },
      { name: "Petrol/Electric", value: "PETROL/ELECTRIC" },
    ],
  },
  {
    value: "terms_archive.primary_transport_type",
    type: "choices",
    choices: [
      { name: "Car", value: "CAR" },
      { name: "Carpool", value: "CARPOOL" },
      { name: "Taxi", value: "TAXI" },
      { name: "Walking", value: "WALKING" },
      { name: "Public Bus", value: "Public Bus" },
      { name: "Train", value: "TRAIN" },
      { name: "Bicycling", value: "BICYCLING" },
    ],
  },
  {
    value: "terms_archive.secondary_transport_type",
    type: "choices",
    choices: [
      { name: "Car", value: "CAR" },
      { name: "Carpool", value: "CARPOOL" },
      { name: "Taxi", value: "TAXI" },
      { name: "Walking", value: "WALKING" },
      { name: "Public Bus", value: "Public Bus" },
      { name: "Train", value: "TRAIN" },
      { name: "Bicycling", value: "BICYCLING" },
    ],
  },
  {
    value: "terms_archive.car_time",
    type: "number",
  },
  {
    value: "terms_archive.carpool_time",
    type: "number",
  },
  {
    value: "terms_archive.bus_time",
    type: "number",
  },
  {
    value: "terms_archive.train_time",
    type: "number",
  },
  {
    value: "terms_archive.walk_time",
    type: "number",
  },
  {
    value: "terms_archive.bicycle_time",
    type: "number",
  },
  {
    value: "terms_archive.total_active_time",
    type: "number",
  },
  {
    value: "terms_archive.car_distance",
    type: "number",
  },
  {
    value: "terms_archive.carpool_distance",
    type: "number",
  },
  {
    value: "terms_archive.bus_distance",
    type: "number",
  },
  {
    value: "terms_archive.train_distance",
    type: "number",
  },
  {
    value: "terms_archive.walk_distance",
    type: "number",
  },
  {
    value: "terms_archive.bicycle_distance",
    type: "number",
  },

  {
    value: "monthly_summary.users",
    type: "number",
  },
  {
    value: "monthly_summary.students_perc",
    type: "number",
  },
  {
    value: "monthly_summary.open_sharing_perc",
    type: "number",
  },
  {
    value: "monthly_summary.notices",
    type: "number",
  },
  {
    value: "monthly_summary.journeys",
    type: "number",
  },
  {
    value: "monthly_summary.chats",
    type: "number",
  },
  {
    value: "monthly_summary.car_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.bus_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.train_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.walk_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.bicycle_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.active_travel_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.co2_per_user",
    type: "number",
  },
  {
    value: "monthly_summary.active_travel_per_user",
    type: "number",
  },
  {
    value: "monthly_summary.electric_vehicles_perc",
    type: "number",
  },
  {
    value: "monthly_summary.carpool_perc",
    type: "number",
  },
  {
    value: "monthly_summary.logged_in",
    type: "number",
  },
];

export const perSchoolFieldOptions = [
  {
    value: "events.event",
    type: "timestamp",
  },
  {
    value: "organizations.id",
    type: "number",
  },
  {
    value: "organizations.name",
  },
  {
    value: "organizations.registration_type",
    type: "choices",
    choices: [
      { name: "REGULAR", value: "REGULAR" },
      { name: "MIS", value: "MIS" },
    ],
  },
  {
    value: "organizations.logo",
  },
  {
    value: "organizations.school_type",
    type: "choices",
    choices: [
      { name: "COUNCIL", value: "COUNCIL" },
      { name: "INDEPENDENT", value: "INDEPENDENT" },
    ],
  },
  {
    value: "organizations.code",
  },
  {
    value: "organizations.staff_code",
  },
  {
    value: "organizations.launch_code",
  },
  {
    value: "organizations.created_at",
    type: "timestamp",
  },
  {
    value: "organizations.vrn_available",
    type: "choices",
    choices: [
      { name: "NO", value: 0 },
      { name: "YES", value: 1 },
    ],
  },

  {
    value: "monthly_summary.users",
    type: "number",
  },
  {
    value: "monthly_summary.students_perc",
    type: "number",
  },
  {
    value: "monthly_summary.open_sharing_perc",
    type: "number",
  },
  {
    value: "monthly_summary.notices",
    type: "number",
  },
  {
    value: "monthly_summary.journeys",
    type: "number",
  },
  {
    value: "monthly_summary.chats",
    type: "number",
  },
  {
    value: "monthly_summary.car_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.bus_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.train_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.walk_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.bicycle_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.active_travel_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.co2_per_user",
    type: "number",
  },
  {
    value: "monthly_summary.active_travel_per_user",
    type: "number",
  },
  {
    value: "monthly_summary.electric_vehicles_perc",
    type: "number",
  },
  {
    value: "monthly_summary.carpool_perc",
    type: "number",
  },
  {
    value: "monthly_summary.logged_in",
    type: "number",
  },
];

export const unregisteredWondeFieldOptions = [
  {
    value: "encrypted_wonde_data.school_id",
    type: "number",
  },
  {
    value: "encrypted_wonde_data.encrypted_email",
  },
  {
    value: "encrypted_wonde_data.encrypted_title",
  },
  {
    value: "encrypted_wonde_data.type",
    type: "choices",
    choices: [
      { name: "parent", value: "parent" },
      { name: "staff", value: "staff" },
    ],
  },
  {
    value: "encrypted_wonde_data.status",
    type: "choices",
    choices: [
      { name: "OK", value: "ok" },
      { name: "no children", value: "no children" },
      { name: "left school", value: "left school" },
    ],
  },
  {
    value: "encrypted_wonde_data.wonde_user_id",
  },
  {
    value: "encrypted_wonde_data.encrypted_first_name",
  },
  {
    value: "encrypted_wonde_data.encrypted_last_name",
  },
  {
    value: "encrypted_wonde_data.consumed",
  },
  {
    value: "encrypted_wonde_data.hash",
  },
  {
    value: "encrypted_wonde_data.email_sent_at",
    type: "timestamp",
  },
  {
    value: "organizations.id",
    type: "number",
  },
  {
    value: "organizations.name",
  },
  {
    value: "organizations.logo",
  },
  {
    value: "organizations.school_type",
    type: "choices",
    choices: [
      { name: "COUNCIL", value: "COUNCIL" },
      { name: "INDEPENDENT", value: "INDEPENDENT" },
    ],
  },
  {
    value: "organizations.code",
  },
  {
    value: "organizations.staff_code",
  },
  {
    value: "organizations.launch_code",
  },
  {
    value: "organizations.created_at",
    type: "timestamp",
  },
  {
    value: "schools_integration.status",
    type: "choices",
    choices: [
      { name: "NOT_LAUNCHED", value: "NOT_LAUNCHED" },
      { name: "SCHOOL_LAUNCHED", value: "SCHOOL_LAUNCHED" },
      { name: "LAUNCHED_UL_SENT", value: "LAUNCHED_UL_SENT" },
    ],
  },
  {
    value: "monthly_summary.users",
    type: "number",
  },
  {
    value: "monthly_summary.students_perc",
    type: "number",
  },
  {
    value: "monthly_summary.open_sharing_perc",
    type: "number",
  },
  {
    value: "monthly_summary.notices",
    type: "number",
  },
  {
    value: "monthly_summary.journeys",
    type: "number",
  },
  {
    value: "monthly_summary.chats",
    type: "number",
  },
  {
    value: "monthly_summary.car_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.bus_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.train_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.walk_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.bicycle_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.active_travel_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.co2_per_user",
    type: "number",
  },
  {
    value: "monthly_summary.active_travel_per_user",
    type: "number",
  },
  {
    value: "monthly_summary.electric_vehicles_perc",
    type: "number",
  },
  {
    value: "monthly_summary.carpool_perc",
    type: "number",
  },
  {
    value: "monthly_summary.logged_in",
    type: "number",
  },
];

export const otherFieldOptions = [
  {
    value: "mi_flow_user_hash",
    type: "text",
  },
  {
    value: "mi_flow_verification_code",
    type: "text",
  },
  {
    value: "mi_flow_first_name",
    type: "text",
  },
];

export const adminContactsFieldOptions = [
  {
    value: "events.event",
    type: "date",
  },
  {
    value: "organizations.name",
  },
  {
    value: "organizations.logo",
  },
  {
    value: "organizations.school_type",
    type: "choices",
    choices: [
      { name: "COUNCIL", value: "COUNCIL" },
      { name: "INDEPENDENT", value: "INDEPENDENT" },
    ],
  },
  {
    value: "organizations.code",
  },
  {
    value: "organizations.staff_code",
  },
  {
    value: "organizations.launch_code",
  },
  {
    value: "organizations.created_at",
    type: "timestamp",
  },

  {
    value: "admin_contacts.email",
    type: "email",
  },
  {
    value: "admin_contacts.first_name",
  },
  {
    value: "admin_contacts.last_name",
  },
  {
    value: "admin_contacts.school_id",
    type: "number",
  },
  {
    value: "admin_contacts.council_id",
    type: "number",
  },
  {
    value: "admin_contacts.administrator",
    type: "choices",
    choices: [
      { name: "Yes", value: 1 },
      { name: "No", value: 0 },
    ],
  },
  {
    value: "admin_contacts.senior_sponsor",
    type: "choices",
    choices: [
      { name: "Yes", value: 1 },
      { name: "No", value: 0 },
    ],
  },
  {
    value: "monthly_summary.users",
    type: "number",
  },
  {
    value: "monthly_summary.students_perc",
    type: "number",
  },
  {
    value: "monthly_summary.open_sharing_perc",
    type: "number",
  },
  {
    value: "monthly_summary.notices",
    type: "number",
  },
  {
    value: "monthly_summary.journeys",
    type: "number",
  },
  {
    value: "monthly_summary.chats",
    type: "number",
  },
  {
    value: "monthly_summary.car_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.bus_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.train_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.walk_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.bicycle_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.active_travel_journeys",
    type: "number",
  },
  {
    value: "monthly_summary.co2_per_user",
    type: "number",
  },
  {
    value: "monthly_summary.active_travel_per_user",
    type: "number",
  },
  {
    value: "monthly_summary.electric_vehicles_perc",
    type: "number",
  },
  {
    value: "monthly_summary.carpool_perc",
    type: "number",
  },
  {
    value: "monthly_summary.logged_in",
    type: "number",
  },
];

export const eventTypes = [
  {
    name: "ACCOUNT_CREATED",
    value: "ACCOUNT_CREATED",
  },
  {
    name: "FIRST_MESSAGE",
    value: "FIRST_MESSAGE",
  },
  {
    name: "FIRST_CHAT",
    value: "FIRST_CHAT",
  },
  {
    name: "ACCOUNT_VERIFIED",
    value: "ACCOUNT_VERIFIED",
  },
  {
    name: "APP_LOGIN",
    value: "APP_LOGIN",
  },
];

export const schoolEventTypes = [
  {
    name: "SCHOOL_LAUNCHED",
    value: "SCHOOL_LAUNCHED",
  },
  {
    name: "SCHOOL_SENT_INVITE_EMAILS",
    value: "SCHOOL_SENT_INVITE_EMAILS",
  },
  {
    name: "SCHOOL_NEW_TERM",
    value: "SCHOOL_NEW_TERM",
  },
];

export const superadminGroupedFieldOptions = [
  {
    value: "users.id",
  },
  {
    value: "terms_archive.id",
  },
  {
    value: "terms_archive_students.id",
  },
  {
    value: "notices.id",
  },
  {
    value: "user_events.id",
  },
  {
    value: "user_events.id",
  },
  {
    value: "journey_profiles.id",
  },
  {
    value: "conversations.id",
  },
  {
    value: "devices.id",
  },
  {
    value: "feed_backs.id",
  },
  {
    value: "invited_parents.id",
  },
  {
    value: "notices_comments.id",
  },
  {
    value: "parkings.id",
  },
  // {
  //   value: "parent_student.id",
  // },
  {
    value: "users_geofences.id",
  },
];

export const stapDataFieldOptions = [
  { value: "step_journeys.id", type: "number" },
  {
    value: "step_journeys.status",
    type: "choices",
    choices: [
      { name: "OK", value: "OK" },
      { name: "IN_PROGRESS", value: "IN_PROGRESS" },
      { name: "PENDING", value: "PENDING" },
      { name: "ERROR", value: "ERROR" },
    ],
  },
  { value: "step_journeys.school_urn", type: "number" },
  { value: "step_journeys.step_journeys_upload_id", type: "number" },
  { value: "step_journeys.student_year", type: "number" },
  {
    value: "step_journeys.studen_year_level",
    type: "choices",
    choices: [
      { name: "PRIMARY", value: "PRIMARY" },
      { name: "SECONDARY", value: "SECONDARY" },
      { name: "ALL_THROUGH", value: "ALL_THROUGH" },
    ],
  },
  { value: "step_journeys.walk_time", type: "number" },
  { value: "step_journeys.car_time", type: "number" },
  { value: "step_journeys.bicycle_time", type: "number" },
  { value: "step_journeys.pt_time", type: "number" },
  { value: "step_journeys.pt_walk_time", type: "number" },
  { value: "step_journeys.walk_distance", type: "number" },
  { value: "step_journeys.car_distance", type: "number" },
  { value: "step_journeys.bicycle_distance", type: "number" },
  { value: "step_journeys.pt_distance", type: "number" },
  { value: "step_journeys.pt_primary_mode", type: "string" },
  { value: "step_journeys.journey_distance", type: "number" },
  { value: "step_journeys.journey_time", type: "number" },
  { value: "step_journeys.total_co2", type: "number" },
  { value: "step_journeys.created_at", type: "timestamp" },
];
